// source: acompanha/commerce_partners/v1/commerce_partners.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartner', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerItem', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerItemInput', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerMapPin', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerStock', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerVisit', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest', null, global);
goog.exportSymbol('proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerItem.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerStock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerStock.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerStock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.CommercePartner.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartner.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerItemInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerItemInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.CommercePartnerVisit.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerVisit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerVisit.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerVisit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerMapPin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerMapPin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.displayName = 'proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.displayName = 'proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.displayName = 'proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.displayName = 'proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.displayName = 'proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.displayName = 'proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.displayName = 'proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.displayName = 'proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.displayName = 'proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.displayName = 'proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.displayName = 'proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.displayName = 'proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.displayName = 'proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.displayName = 'proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.displayName = 'proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.displayName = 'proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.displayName = 'proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.displayName = 'proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.displayName = 'proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.displayName = 'proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.displayName = 'proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.displayName = 'proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
partnerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
productUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
productName: jspb.Message.getFieldWithDefault(msg, 4, ""),
itemKind: jspb.Message.getFieldWithDefault(msg, 5, ""),
minInitialQty: jspb.Message.getFieldWithDefault(msg, 6, 0),
minReorderQty: jspb.Message.getFieldWithDefault(msg, 7, 0),
displayQty: jspb.Message.getFieldWithDefault(msg, 8, 0),
wholesaleCents: jspb.Message.getFieldWithDefault(msg, 9, 0),
suggestedRetailCents: jspb.Message.getFieldWithDefault(msg, 10, 0),
consignmentRepasseCents: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerItem;
  return proto.acompanha.commerce_partners.v1.CommercePartnerItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductUuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemKind(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinInitialQty(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinReorderQty(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayQty(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWholesaleCents(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuggestedRetailCents(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConsignmentRepasseCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartnerUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemKind();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMinInitialQty();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMinReorderQty();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getDisplayQty();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getWholesaleCents();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getSuggestedRetailCents();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getConsignmentRepasseCents();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string partner_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getPartnerUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setPartnerUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_uuid = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getProductUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setProductUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string product_name = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string item_kind = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getItemKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setItemKind = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 min_initial_qty = 6;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getMinInitialQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setMinInitialQty = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 min_reorder_qty = 7;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getMinReorderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setMinReorderQty = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 display_qty = 8;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getDisplayQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setDisplayQty = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 wholesale_cents = 9;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getWholesaleCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setWholesaleCents = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 suggested_retail_cents = 10;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getSuggestedRetailCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setSuggestedRetailCents = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 consignment_repasse_cents = 11;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.getConsignmentRepasseCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItem.prototype.setConsignmentRepasseCents = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerStock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.toObject = function(includeInstance, msg) {
  var f, obj = {
partnerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
productUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
productName: jspb.Message.getFieldWithDefault(msg, 3, ""),
quantityOnHand: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerStock;
  return proto.acompanha.commerce_partners.v1.CommercePartnerStock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantityOnHand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerStock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartnerUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuantityOnHand();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string partner_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.getPartnerUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.setPartnerUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.getProductUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.setProductUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_name = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 quantity_on_hand = 4;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.getQuantityOnHand = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerStock.prototype.setQuantityOnHand = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.CommercePartner.repeatedFields_ = [23,24];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartner.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
customerUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactName: jspb.Message.getFieldWithDefault(msg, 5, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 6, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 7, ""),
modality: jspb.Message.getFieldWithDefault(msg, 8, ""),
status: jspb.Message.getFieldWithDefault(msg, 9, ""),
address: jspb.Message.getFieldWithDefault(msg, 10, ""),
addressNumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
addressComplement: jspb.Message.getFieldWithDefault(msg, 12, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 13, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 14, ""),
city: jspb.Message.getFieldWithDefault(msg, 15, ""),
state: jspb.Message.getFieldWithDefault(msg, 16, ""),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
hasCoordinates: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
visitFrequency: jspb.Message.getFieldWithDefault(msg, 20, ""),
firstVisitOn: jspb.Message.getFieldWithDefault(msg, 21, ""),
notes: jspb.Message.getFieldWithDefault(msg, 22, ""),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerItem.toObject, includeInstance),
stockList: jspb.Message.toObjectList(msg.getStockList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerStock.toObject, includeInstance),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartner;
  return proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerUuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactPhone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactEmail(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setModality(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressNumber(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressComplement(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasCoordinates(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitFrequency(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstVisitOn(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 23:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerItem;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 24:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerStock;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerStock.deserializeBinaryFromReader);
      msg.addStock(value);
      break;
    case 25:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getModality();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAddressNumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAddressComplement();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getHasCoordinates();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getVisitFrequency();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getFirstVisitOn();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerItem.serializeBinaryToWriter
    );
  }
  f = message.getStockList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerStock.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string customer_uuid = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getCustomerUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setCustomerUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_name = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string contact_phone = 6;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string contact_email = 7;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string modality = 8;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getModality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setModality = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string status = 9;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string address = 10;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string address_number = 11;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getAddressNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setAddressNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string address_complement = 12;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getAddressComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setAddressComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string neighborhood = 13;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string zip_code = 14;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string city = 15;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string state = 16;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional double latitude = 17;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double longitude = 18;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional bool has_coordinates = 19;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getHasCoordinates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setHasCoordinates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional string visit_frequency = 20;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getVisitFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setVisitFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string first_visit_on = 21;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getFirstVisitOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setFirstVisitOn = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string notes = 22;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * repeated CommercePartnerItem items = 23;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItem>}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerItem, 23));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItem>} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * repeated CommercePartnerStock stock = 24;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerStock>}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getStockList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerStock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerStock, 24));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerStock>} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setStockList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerStock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.addStock = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerStock, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.clearStockList = function() {
  return this.setStockList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 25;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 25));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartner.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 26) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.toObject = function(includeInstance, msg) {
  var f, obj = {
productUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
itemKind: jspb.Message.getFieldWithDefault(msg, 2, ""),
minInitialQty: jspb.Message.getFieldWithDefault(msg, 3, 0),
minReorderQty: jspb.Message.getFieldWithDefault(msg, 4, 0),
displayQty: jspb.Message.getFieldWithDefault(msg, 5, 0),
wholesaleCents: jspb.Message.getFieldWithDefault(msg, 6, 0),
suggestedRetailCents: jspb.Message.getFieldWithDefault(msg, 7, 0),
consignmentRepasseCents: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerItemInput;
  return proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemKind(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinInitialQty(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinReorderQty(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayQty(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWholesaleCents(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuggestedRetailCents(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConsignmentRepasseCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemKind();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMinInitialQty();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMinReorderQty();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDisplayQty();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getWholesaleCents();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSuggestedRetailCents();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getConsignmentRepasseCents();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string product_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getProductUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setProductUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string item_kind = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getItemKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setItemKind = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 min_initial_qty = 3;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getMinInitialQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setMinInitialQty = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 min_reorder_qty = 4;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getMinReorderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setMinReorderQty = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 display_qty = 5;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getDisplayQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setDisplayQty = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 wholesale_cents = 6;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getWholesaleCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setWholesaleCents = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 suggested_retail_cents = 7;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getSuggestedRetailCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setSuggestedRetailCents = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 consignment_repasse_cents = 8;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.getConsignmentRepasseCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.prototype.setConsignmentRepasseCents = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.repeatedFields_ = [16,17,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
partnerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
plannedOn: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
orderUuid: jspb.Message.getFieldWithDefault(msg, 7, ""),
partnerName: jspb.Message.getFieldWithDefault(msg, 8, ""),
partnerModality: jspb.Message.getFieldWithDefault(msg, 9, ""),
partnerAddress: jspb.Message.getFieldWithDefault(msg, 10, ""),
partnerCity: jspb.Message.getFieldWithDefault(msg, 11, ""),
partnerContactName: jspb.Message.getFieldWithDefault(msg, 12, ""),
partnerLatitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
partnerLongitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
partnerHasCoordinates: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
linesList: jspb.Message.toObjectList(msg.getLinesList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.toObject, includeInstance),
partnerItemsList: jspb.Message.toObjectList(msg.getPartnerItemsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerItem.toObject, includeInstance),
partnerStockList: jspb.Message.toObjectList(msg.getPartnerStockList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerStock.toObject, includeInstance),
completedAt: (f = msg.getCompletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
visitedOn: jspb.Message.getFieldWithDefault(msg, 22, ""),
receiptJson: jspb.Message.getFieldWithDefault(msg, 23, ""),
partnerContactPhone: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
  return proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlannedOn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderUuid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerModality(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerAddress(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerCity(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerContactName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPartnerLatitude(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPartnerLongitude(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPartnerHasCoordinates(value);
      break;
    case 16:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.deserializeBinaryFromReader);
      msg.addLines(value);
      break;
    case 17:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerItem;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerItem.deserializeBinaryFromReader);
      msg.addPartnerItems(value);
      break;
    case 18:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerStock;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerStock.deserializeBinaryFromReader);
      msg.addPartnerStock(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCompletedAt(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitedOn(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptJson(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerContactPhone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartnerUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlannedOn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrderUuid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPartnerName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPartnerModality();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPartnerAddress();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPartnerCity();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPartnerContactName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPartnerLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getPartnerLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getPartnerHasCoordinates();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.serializeBinaryToWriter
    );
  }
  f = message.getPartnerItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerItem.serializeBinaryToWriter
    );
  }
  f = message.getPartnerStockList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerStock.serializeBinaryToWriter
    );
  }
  f = message.getCompletedAt();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getVisitedOn();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getReceiptJson();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getPartnerContactPhone();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string partner_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_uuid = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string planned_on = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPlannedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPlannedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string order_uuid = 7;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getOrderUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setOrderUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string partner_name = 8;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string partner_modality = 9;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerModality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerModality = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string partner_address = 10;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string partner_city = 11;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerCity = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string partner_contact_name = 12;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional double partner_latitude = 13;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double partner_longitude = 14;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional bool partner_has_coordinates = 15;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerHasCoordinates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerHasCoordinates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * repeated CommercePartnerVisitLine lines = 16;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine>}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getLinesList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine, 16));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine>} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.addLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.clearLinesList = function() {
  return this.setLinesList([]);
};


/**
 * repeated CommercePartnerItem partner_items = 17;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItem>}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerItemsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerItem, 17));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItem>} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItem}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.addPartnerItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.clearPartnerItemsList = function() {
  return this.setPartnerItemsList([]);
};


/**
 * repeated CommercePartnerStock partner_stock = 18;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerStock>}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerStockList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerStock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerStock, 18));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerStock>} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerStockList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerStock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerStock}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.addPartnerStock = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerStock, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.clearPartnerStockList = function() {
  return this.setPartnerStockList([]);
};


/**
 * optional google.protobuf.Timestamp completed_at = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getCompletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setCompletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.clearCompletedAt = function() {
  return this.setCompletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.hasCompletedAt = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
*/
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional string visited_on = 22;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getVisitedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setVisitedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string receipt_json = 23;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getReceiptJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setReceiptJson = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string partner_contact_phone = 24;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.getPartnerContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisit.prototype.setPartnerContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
visitUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
productUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
productName: jspb.Message.getFieldWithDefault(msg, 4, ""),
soldQty: jspb.Message.getFieldWithDefault(msg, 5, 0),
restockedQty: jspb.Message.getFieldWithDefault(msg, 6, 0),
orderedQty: jspb.Message.getFieldWithDefault(msg, 7, 0),
unitPriceCents: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine;
  return proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductUuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSoldQty(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRestockedQty(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderedQty(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnitPriceCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSoldQty();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRestockedQty();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getOrderedQty();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUnitPriceCents();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string visit_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_uuid = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getProductUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setProductUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string product_name = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 sold_qty = 5;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getSoldQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setSoldQty = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 restocked_qty = 6;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getRestockedQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setRestockedQty = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 ordered_qty = 7;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getOrderedQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setOrderedQty = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 unit_price_cents = 8;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.getUnitPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLine.prototype.setUnitPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.toObject = function(includeInstance, msg) {
  var f, obj = {
productUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
soldQty: jspb.Message.getFieldWithDefault(msg, 2, 0),
restockedQty: jspb.Message.getFieldWithDefault(msg, 3, 0),
orderedQty: jspb.Message.getFieldWithDefault(msg, 4, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 5, 0),
registerSale: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
registerSaleQty: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput;
  return proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSoldQty(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRestockedQty(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderedQty(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRegisterSale(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRegisterSaleQty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSoldQty();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRestockedQty();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getOrderedQty();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRegisterSale();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRegisterSaleQty();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string product_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getProductUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setProductUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 sold_qty = 2;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getSoldQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setSoldQty = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 restocked_qty = 3;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getRestockedQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setRestockedQty = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 ordered_qty = 4;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getOrderedQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setOrderedQty = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 quantity = 5;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool register_sale = 6;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getRegisterSale = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setRegisterSale = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 register_sale_qty = 7;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.getRegisterSaleQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.prototype.setRegisterSaleQty = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.toObject = function(includeInstance, msg) {
  var f, obj = {
visitUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
partnerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
label: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
address: jspb.Message.getFieldWithDefault(msg, 5, ""),
city: jspb.Message.getFieldWithDefault(msg, 6, ""),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
hasCoordinates: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerMapPin;
  return proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasCoordinates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartnerUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getHasCoordinates();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string visit_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string partner_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getPartnerUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setPartnerUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string address = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string city = 6;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double latitude = 7;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double longitude = 8;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional bool has_coordinates = 9;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.getHasCoordinates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.prototype.setHasCoordinates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
address: jspb.Message.getFieldWithDefault(msg, 2, ""),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
hasCoordinates: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin;
  return proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasCoordinates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getHasCoordinates();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double latitude = 3;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double longitude = 4;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool has_coordinates = 5;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.getHasCoordinates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} returns this
 */
proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.prototype.setHasCoordinates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
modality: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest;
  return proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModality(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getModality();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} returns this
*/
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string modality = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.getModality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.setModality = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.commerce_partners.v1.CommercePartner.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse;
  return proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartner;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated CommercePartner data = 1;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartner>}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartner>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartner, 1));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartner>} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} returns this
*/
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartner=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.commerce_partners.v1.CommercePartner, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartner;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartner data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartner} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartner, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartner|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
contactName: jspb.Message.getFieldWithDefault(msg, 2, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 3, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
modality: jspb.Message.getFieldWithDefault(msg, 5, ""),
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
address: jspb.Message.getFieldWithDefault(msg, 7, ""),
addressNumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
addressComplement: jspb.Message.getFieldWithDefault(msg, 9, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 10, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 11, ""),
city: jspb.Message.getFieldWithDefault(msg, 12, ""),
state: jspb.Message.getFieldWithDefault(msg, 13, ""),
visitFrequency: jspb.Message.getFieldWithDefault(msg, 14, ""),
firstVisitOn: jspb.Message.getFieldWithDefault(msg, 15, ""),
notes: jspb.Message.getFieldWithDefault(msg, 16, ""),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest;
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setModality(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressNumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressComplement(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitFrequency(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstVisitOn(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 17:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerItemInput;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContactName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getModality();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddressNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddressComplement();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getVisitFrequency();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getFirstVisitOn();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contact_name = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string contact_phone = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string contact_email = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string modality = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getModality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setModality = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string address = 7;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string address_number = 8;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getAddressNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setAddressNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address_complement = 9;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getAddressComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setAddressComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string neighborhood = 10;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string zip_code = 11;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string city = 12;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string state = 13;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string visit_frequency = 14;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getVisitFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setVisitFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string first_visit_on = 15;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getFirstVisitOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setFirstVisitOn = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string notes = 16;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * repeated CommercePartnerItemInput items = 17;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput>}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerItemInput, 17));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput>} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
*/
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerItemInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse;
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartner;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartner data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartner} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartner, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartner|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse} returns this
*/
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.repeatedFields_ = [18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
contactName: jspb.Message.getFieldWithDefault(msg, 3, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
modality: jspb.Message.getFieldWithDefault(msg, 6, ""),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
address: jspb.Message.getFieldWithDefault(msg, 8, ""),
addressNumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
addressComplement: jspb.Message.getFieldWithDefault(msg, 10, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 11, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 12, ""),
city: jspb.Message.getFieldWithDefault(msg, 13, ""),
state: jspb.Message.getFieldWithDefault(msg, 14, ""),
visitFrequency: jspb.Message.getFieldWithDefault(msg, 15, ""),
firstVisitOn: jspb.Message.getFieldWithDefault(msg, 16, ""),
notes: jspb.Message.getFieldWithDefault(msg, 17, ""),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest;
  return proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setModality(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressNumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressComplement(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitFrequency(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstVisitOn(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 18:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerItemInput;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContactName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getModality();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddressNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAddressComplement();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getVisitFrequency();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFirstVisitOn();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerItemInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string contact_name = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getContactName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setContactName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string contact_phone = 4;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_email = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string modality = 6;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getModality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setModality = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string address = 8;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address_number = 9;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getAddressNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setAddressNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string address_complement = 10;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getAddressComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setAddressComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string neighborhood = 11;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string zip_code = 12;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string city = 13;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string state = 14;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string visit_frequency = 15;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getVisitFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setVisitFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string first_visit_on = 16;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getFirstVisitOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setFirstVisitOn = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string notes = 17;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * repeated CommercePartnerItemInput items = 18;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput>}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerItemInput, 18));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput>} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
*/
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerItemInput}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerItemInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse;
  return proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartner;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartner data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartner} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartner, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartner|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse} returns this
*/
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse} returns this
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest;
  return proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} returns this
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
linesList: jspb.Message.toObjectList(msg.getLinesList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest;
  return proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.deserializeBinaryFromReader);
      msg.addLines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} returns this
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated CommercePartnerVisitLineInput lines = 2;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.getLinesList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, 2));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>} value
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} returns this
*/
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.setLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.addLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} returns this
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest.prototype.clearLinesList = function() {
  return this.setLinesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse;
  return proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartner;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartner data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartner} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartner, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartner|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse} returns this
*/
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse} returns this
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
notes: jspb.Message.getFieldWithDefault(msg, 2, ""),
linesList: jspb.Message.toObjectList(msg.getLinesList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.toObject, includeInstance),
paid: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest;
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 3:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.deserializeBinaryFromReader);
      msg.addLines(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.serializeBinaryToWriter
    );
  }
  f = message.getPaid();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string notes = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CommercePartnerVisitLineInput lines = 3;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.getLinesList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, 3));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} returns this
*/
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.setLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.addLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.clearLinesList = function() {
  return this.setLinesList([]);
};


/**
 * optional bool paid = 4;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.getPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest.prototype.setPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
orderUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
visitUuid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse;
  return proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string order_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.prototype.getOrderUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.prototype.setOrderUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string visit_uuid = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse} returns this
 */
proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest;
  return proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} returns this
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse;
  return proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartner;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartner.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartner.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartner data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartner}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartner} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartner, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartner|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse} returns this
*/
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse} returns this
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
todayCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
tomorrowCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
todayVisitsList: jspb.Message.toObjectList(msg.getTodayVisitsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject, includeInstance),
tomorrowVisitsList: jspb.Message.toObjectList(msg.getTomorrowVisitsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTodayCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTomorrowCount(value);
      break;
    case 3:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.addTodayVisits(value);
      break;
    case 4:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.addTomorrowVisits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTodayCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTomorrowCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTodayVisitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
  f = message.getTomorrowVisitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 today_count = 1;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.getTodayCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.setTodayCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 tomorrow_count = 2;
 * @return {number}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.getTomorrowCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.setTomorrowCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated CommercePartnerVisit today_visits = 3;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.getTodayVisitsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 3));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.setTodayVisitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.addTodayVisits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.clearTodayVisitsList = function() {
  return this.setTodayVisitsList([]);
};


/**
 * repeated CommercePartnerVisit tomorrow_visits = 4;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.getTomorrowVisitsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 4));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.setTomorrowVisitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.addTomorrowVisits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.prototype.clearTomorrowVisitsList = function() {
  return this.setTomorrowVisitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
from: jspb.Message.getFieldWithDefault(msg, 1, ""),
to: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest;
  return proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string from = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string to = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject, includeInstance),
from: jspb.Message.getFieldWithDefault(msg, 2, ""),
to: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse;
  return proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated CommercePartnerVisit data = 1;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 1));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} returns this
*/
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional string from = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string to = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse} returns this
 */
proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
origin: (f = msg.getOrigin()) && proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.toObject(includeInstance, f),
pinsList: jspb.Message.toObjectList(msg.getPinsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.toObject, includeInstance),
visitsList: jspb.Message.toObjectList(msg.getVisitsList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.deserializeBinaryFromReader);
      msg.setOrigin(value);
      break;
    case 3:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerMapPin;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.deserializeBinaryFromReader);
      msg.addPins(value);
      break;
    case 4:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.addVisits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrigin();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin.serializeBinaryToWriter
    );
  }
  f = message.getPinsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerMapPin.serializeBinaryToWriter
    );
  }
  f = message.getVisitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CommercePartnerMapOrigin origin = 2;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.getOrigin = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin, 2));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartnerMapOrigin|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.setOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.clearOrigin = function() {
  return this.setOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.hasOrigin = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CommercePartnerMapPin pins = 3;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin>}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.getPinsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerMapPin, 3));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin>} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.setPinsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerMapPin}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.addPins = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerMapPin, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.clearPinsList = function() {
  return this.setPinsList([]);
};


/**
 * repeated CommercePartnerVisit visits = 4;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.getVisitsList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 4));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisit>} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.setVisitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.addVisits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.prototype.clearVisitsList = function() {
  return this.setVisitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
visitUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string visit_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse;
  return proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartnerVisit data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartnerVisit} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartnerVisit|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse} returns this
*/
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse} returns this
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
visitUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
notes: jspb.Message.getFieldWithDefault(msg, 2, ""),
linesList: jspb.Message.toObjectList(msg.getLinesList(),
    proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.toObject, includeInstance),
paid: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
visitedOn: jspb.Message.getFieldWithDefault(msg, 5, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 6, ""),
paymentDate: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest;
  return proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 3:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.deserializeBinaryFromReader);
      msg.addLines(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitedOn(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput.serializeBinaryToWriter
    );
  }
  f = message.getPaid();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getVisitedOn();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPaymentDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string visit_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string notes = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CommercePartnerVisitLineInput lines = 3;
 * @return {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getLinesList = function() {
  return /** @type{!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, 3));
};


/**
 * @param {!Array<!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput>} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
*/
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.addLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.commerce_partners.v1.CommercePartnerVisitLineInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.clearLinesList = function() {
  return this.setLinesList([]);
};


/**
 * optional bool paid = 4;
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string visited_on = 5;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getVisitedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setVisitedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string payment_method = 6;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string payment_date = 7;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.getPaymentDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest.prototype.setPaymentDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse;
  return proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartnerVisit data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartnerVisit} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartnerVisit|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse} returns this
*/
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse} returns this
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
visitUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 2, ""),
paymentDate: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest;
  return proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaymentDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string visit_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} returns this
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string payment_method = 2;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} returns this
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string payment_date = 3;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.getPaymentDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} returns this
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest.prototype.setPaymentDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.commerce_partners.v1.CommercePartnerVisit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse;
  return proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.commerce_partners.v1.CommercePartnerVisit;
      reader.readMessage(value,proto.acompanha.commerce_partners.v1.CommercePartnerVisit.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.commerce_partners.v1.CommercePartnerVisit.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercePartnerVisit data = 1;
 * @return {?proto.acompanha.commerce_partners.v1.CommercePartnerVisit}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.commerce_partners.v1.CommercePartnerVisit} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.commerce_partners.v1.CommercePartnerVisit, 1));
};


/**
 * @param {?proto.acompanha.commerce_partners.v1.CommercePartnerVisit|undefined} value
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse} returns this
*/
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse} returns this
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
visitUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest;
  return proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisitUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string visit_uuid = 1;
 * @return {string}
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.prototype.getVisitUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} returns this
 */
proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest.prototype.setVisitUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.commerce_partners.v1);
